module.exports = __webpack_public_path__ + "img/driver-license-read-sample.c8e0c383.png";